import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollMainContainerToTop } from "../utils/layoutShell";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    // Clear any leaked global scroll locks when navigating between routes.
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    document.documentElement.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("padding-right");

    const resetScroll = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      scrollMainContainerToTop();
    };

    // reset immediately and once more on the next frame to avoid timing races
    resetScroll();
    const rafId = requestAnimationFrame(resetScroll);
    return () => cancelAnimationFrame(rafId);
  }, [pathname]);

  return null;
}
